module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon1b.da728cb9.png";